<script setup lang="ts">
import { LOCALE_EN, LOCALE_FR, LOCALE_NL } from '@/i18n/main'
import { brokerIsStroobants } from '@/utils/brokers'
import { useI18n } from 'vue-i18n'

import MockupEN from '@/assets/svg/illustrations/on_b2b_en_5.svg?component'
import MockupNL from '@/assets/svg/illustrations/on_b2b_nl_5.svg?component'
import MockupFR from '@/assets/svg/illustrations/onboarding_1_b2b.svg?component'
import StroobantsMockup from '@/assets/svg/illustrations/onboarding_5_b2b_str.svg?component'

const { locale } = useI18n()
</script>

<template>
  <div class="xs:flex flex-row-reverse gap-8 h-full pb-16 xs:pb-0">
    <div class="rounded-2xl overflow-hidden xs:w-1/2">
      <StroobantsMockup v-if="brokerIsStroobants()" class="min-w-full min-h-full object-cover" />
      <template v-else>
        <MockupFR class="min-w-full min-h-full object-cover" v-if="locale === LOCALE_FR" />
        <MockupEN class="min-w-full min-h-full object-cover" v-else-if="locale === LOCALE_EN" />
        <MockupNL class="min-w-full min-h-full object-cover" v-else-if="locale === LOCALE_NL" />
      </template>
    </div>
    <div class="my-8 xs:my-0 h-full xs:pb-12 xs:w-1/2">
      <h2 class="font-medium text-2xl leading-7">{{ $t('modals.b2b_onboarding.step_5.title') }}</h2>
      <p class="text-sm my-4">
        {{ $t('modals.b2b_onboarding.step_5.description') }}
      </p>
    </div>
  </div>
</template>
